if (!customElements.get("main-collection")) {
 class MainCollection extends HTMLElement {
  connectedCallback() {
   this.querySelector("select[selectSort]").addEventListener(
    "change",
    this.sortCollection
   );
   this.listenInputFilter();
  }

  listenInputFilter() {
   const urlEncode = decodeURIComponent(location.search);
   this.querySelectorAll('[filterCheckbox] input[type="checkbox"]').forEach(
    (checkbox) => {
     checkbox.addEventListener("change", this.changeFilter);
     if (urlEncode.includes(checkbox.value)) {
      checkbox.checked = true;
     }
    }
   );
  }

  renderSectionFromFetch(url, event) {
   fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
     const html = responseText;
     this.renderFilters(html);
     this.renderProductGridContainer(html);
    });
  }

  renderProductGridContainer(html) {
   document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
    .parseFromString(html, "text/html")
    .getElementById("ProductGridContainer").innerHTML;
  }
  renderFilters(html) {
   document.getElementById("ProductFilterContainer").innerHTML = new DOMParser()
    .parseFromString(html, "text/html")
    .getElementById("ProductFilterContainer").innerHTML;

   this.listenInputFilter();
  }

  updateUrl(url) {
   const searchParams =
    url.indexOf("?") == -1 ? "" : url.slice(url.indexOf("?") + 1);
   history.pushState(
    { searchParams },
    "",
    `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
   );
   this.renderSectionFromFetch(url);
  }

  changeFilter = (e) => {
   const { checked } = e.target;
   const { urladd, urlremove } = e.target.parentElement.parentElement.dataset;
   // Cập nhật URL trình duyệt
   const url = checked ? urladd : urlremove;
   this.updateUrl(url);
  };
  sortCollection = (e) => {
   const { target: selectElement } = e;
   var sortOption = selectElement.value;
   var currentUrl = window.location.href;

   // Xoá query parameter sort_by nếu có
   currentUrl = currentUrl.replace(/[\?&]sort_by=[^&]+/, "");

   // Thêm query parameter mới
   var newUrl =
    currentUrl +
    (currentUrl.indexOf("?") !== -1 ? "&" : "?") +
    "sort_by=" +
    sortOption;
   this.updateUrl(newUrl);
  };
 }

 customElements.define("main-collection", MainCollection);
}
